/**
 * The single route registry, read from routes.generated.json (written by
 * scripts/build-content.mjs). Static pages and content pages live in one list;
 * everything else (App.js, seo.js, Seo.jsx, the templates) reads it through
 * here so no second list can drift.
 */
import registry from "./routes.generated.json";

export const ALL_ROUTES = registry.routes;
export const CONTENT_ROUTES = ALL_ROUTES.filter((r) => r.type !== "static");

const index = new Map(ALL_ROUTES.map((r) => [r.path, r]));

export const byPath = (path) => index.get(path);

/** Entries a page declares as its language twin, as [lang, entry] pairs. */
export const alternatesOf = (entry) => {
  if (!entry || !entry.alternate) return [];
  const twin = byPath(entry.alternate);
  return twin ? [twin] : [];
};
